<template>
  <div>
    <b-modal ref="certificate-modal" title="Certificate" size="lg" ok-only>

      <b-img :src="image_path"
             fluid alt="Certificate"/>

    </b-modal>
  </div>
</template>

<script>

export default {
  props: {
    image_path: {
      type: String,
      default: ''
    }
  },
  data: () => ({}),
  computed: {
    certificateImage: {
      get() {
        return this.image_path
      },
      set(newValue) {
        this.image_path = newValue
      }
    }
  },
  mounted: function () {
    //this.$refs['certificate-modal'].show()
  },
  methods: {
    enableModal() {
      this.certificateImage = this.image_path
      this.$refs['certificate-modal'].show()
    },
    handleOk() {
      this.image_path = ''
    }
  }
}

</script>
